<template>
  <v-container class="px-0 py-0" fluid>
    <v-row>
      <v-col>
        <PartForm :propsPartCd="partCd" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import PartForm from '@/components/organisms/master/form/PartForm'

export default {
  name: 'PartPage',

  components: {
    PartForm,
  },

  data() {
    return {
      partCd: '',
    }
  },

  created() {
    const query = this.$route.query
    if (query) {
      this.partCd = query.partCd
    }
  },
}
</script>
